import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "xtdiaog"
};
const _hoisted_2 = {
  key: 0,
  style: {
    "color": "#ccc"
  }
};
const _hoisted_3 = {
  key: 1
};
const _hoisted_4 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "align-items": "center"
  }
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  key: 1
};
const _hoisted_7 = {
  key: 0,
  style: {
    "color": "#ccc"
  }
};
const _hoisted_8 = {
  key: 1
};
const _hoisted_9 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "align-items": "center"
  }
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
  key: 1
};
const _hoisted_12 = {
  key: 0,
  style: {
    "color": "#ccc"
  }
};
const _hoisted_13 = {
  key: 1
};
import { getUsers } from '../../utils/lc';
import { getCurrentInstance, reactive, computed } from "vue";
import { ElMessage, ElMessageBox } from 'element-plus';

/* 数据层 */

export default {
  __name: 'lcDailogxt',
  props: ['projectId', 'xtshow'],
  emits: ['update:xtshow', 'getinit'],
  setup(__props, {
    emit: __emit
  }) {
    const {
      proxy
    } = getCurrentInstance();
    const pop = __props;
    let data = reactive({
      dateTime: null,
      tableData: [],
      project_id: '',
      userlist: [],
      userlistall: [],
      selecttag: true,
      //判断单前行是否选择还是取消选中
      multipleSelection: [] // 表格选中
    });
    /* 初始化 */
    getUsers({
      page: 1,
      size: 9999999,
      nickname: ''
    }).then(res => {
      res.data.forEach(it => {
        it.isleaderUserIdShow = false;
        it.isdownTimeShow = false;
      });
      data.userlist = JSON.parse(JSON.stringify(res.data));
      data.userlistall = JSON.parse(JSON.stringify(res.data));
    });
    const fullName = computed(() => {
      return function (id) {
        if (id && data.userlistall && data.userlistall.length > 0) {
          let item = data.userlistall.filter(it => {
            return it.id == id;
          });
          return item && item.length > 0 ? item[0].nickname : '';
        }
      };
    });
    getlist();
    /* 方法层 */
    const emits = __emit;
    function getRowCol(row, column, index, type) {
      data.tableData.forEach(it => {
        it.isleaderUserIdShow = false;
        it.isdownTimeShow = false;
      });
      data.userlist = JSON.parse(JSON.stringify(data.userlistall));
      if (type == 'downTime') {
        data.tableData[index].isdownTimeShow = true;
      }
      if (type == 'leaderUser') {
        data.tableData[index].isleaderUserIdShow = true;
      }
    }
    function remoteMethod(query) {
      // console.log('yuancheng', query)
      getUsers({
        page: 1,
        size: 9999999,
        nickname: query
      }).then(res => {
        res.data.forEach(it => {
          it.isleaderUserIdShow = false;
          it.isdownTimeShow = false;
        });
        data.userlist = JSON.parse(JSON.stringify(res.data));
      });
    }
    //获取即将需要下推的任务
    function getlist() {
      proxy.$http.showLoading(false).get('project/project/push_init_data', {
        project_id: pop.projectId
      }).then(res => {
        let isshowlist = [];
        if (res.errno == 200) {
          res.data.forEach(it => {
            it.required_time = it.required_time_text;
            it.checked = it.committed_step == 1 ? true : false;
            if (it.is_show == 1) {
              isshowlist.push(it);
            }
          });
          data.tableData = res.data;
          if (isshowlist && isshowlist.length > 0) {
            setTimeout(() => {
              data.selecttag = true;
              isshowlist.forEach(it => {
                proxy.$refs.multipleTable.toggleRowSelection(it, true);
              });
            }, 800);
          }
        } else {
          ElMessage({
            type: 'error',
            message: res.errmsg
          });
        }
      });
    }
    // 禁止勾選
    function selectable(row, index) {
      return row.examine_status !== 20;
    }
    function tableSelect(rows, row) {
      data.multipleSelection = rows;
      let selected = rows.length && rows.indexOf(row) !== -1;
      data.selecttag = selected;
      if (!selected) {
        cancelchecked(data.multipleSelection, row.basetask_id);
      }
      console.log(selected); // true就是选中，0或者false是取消选中
      // console.log(selected, data.selecttag)  // true就是选中，0或者false是取消选中
      // 判断 知识产权需求=知识产权申请   认证需求=认证    包装原型=包装设计
      tbchecked('ZSCQXQ', 'ZSCQSQ', rows, row);
      tbchecked('RZXQ', 'RZ', rows, row);
      tbchecked('BZYX', 'BZSJ', rows, row);
      proxy.$refs.multipleTable.doLayout();
    }
    // 同步选择 知识产权需求=知识产权申请   认证需求=认证    包装原型=包装设计
    function tbchecked(value1, value2, rows, row) {
      if (row.code == value1 || row.code == value2) {
        let zscheck = [];
        zscheck = rows ? rows.filter(it => {
          return it.code == value1 || it.code == value2;
        }) : [];
        if (zscheck && zscheck.length == 1 && data.selecttag) {
          data.tableData.forEach(it => {
            if (it.code == value1 || it.code == value2) {
              setTimeout(() => {
                proxy.$refs.multipleTable.toggleRowSelection(it, true);
              }, 800);
            }
          });
        }
        if ((row.code == value1 || row.code == value2) && !data.selecttag) {
          if (zscheck.length !== 0) {
            data.tableData.forEach(it => {
              if (it.code == value1 || it.code == value2) {
                data.multipleSelection.forEach((it, index) => {
                  if (it.code == value1 || it.code == value2) {
                    data.multipleSelection.splice(index, 1);
                  }
                });
                proxy.$refs.multipleTable.toggleRowSelection(it, false);
              }
            });
          }
        }
      }
    }

    // 表格选择
    function handleSelectionChange(val, tag) {
      data.multipleSelection = val;
    }
    // 选中全部
    function selectAllChange(value) {
      let checkdids = value.map(v => v.basetask_id);
      data.tableData.forEach(it => {
        if (!checkdids.includes(it.basetask_id) && it.examine_status !== 20) {
          it.leader_user_id = null;
          it.checked = false;
        }
      });
    }
    // 下推去掉勾选同步去掉是否管家步骤和负责人
    function cancelchecked(list, basetask_id) {
      let checkdids = list.map(v => v.basetask_id);
      data.tableData.forEach(it => {
        if (!checkdids.includes(it.basetask_id) && basetask_id == it.basetask_id) {
          it.leader_user_id = null;
          it.checked = false;
        }
      });
    }
    //关闭的点击事件
    function handleClose() {
      emits('update:xtshow', false);
    }
    // 按鈕下推
    function handlePush(type) {
      let newPushDate = [];
      let tag = true;
      if (type == 'check' && data.multipleSelection.length > 0) {
        data.multipleSelection.forEach(it => {
          if (it.checked) {
            it.committed_step = 1;
          } else {
            it.committed_step = 0;
          }
          newPushDate.push(it);
          if (!it.leader_user_id) {
            tag = false;
          }
        });
        if (tag) {
          proxy.$http.showLoading(false).post('project/project/push', {
            task: newPushDate,
            project_id: pop.projectId
          }).then(res => {
            if (res.errno == 200) {
              getlist();
              emits('update:xtshow', false);
              emits('getinit');
              ElMessageBox.confirm(res.errmsg, '提示', {
                type: 'warning',
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                beforeClose: (action, instance, done) => {
                  if (action === 'confirm') {
                    done();
                  }
                }
              });
            } else {
              ElMessage({
                type: 'error',
                message: res.errmsg
              });
            }
          });
        } else {
          ElMessage({
            type: 'error',
            message: '请选择任务负责人'
          });
        }
      } else {
        ElMessage({
          type: 'error',
          message: '请选择要下推的数据'
        });
      }
    }
    return (_ctx, _cache) => {
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_edit = _resolveComponent("edit");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        title: "下推列表",
        "model-value": __props.xtshow,
        width: "750px",
        "before-close": handleClose,
        center: false
      }, {
        default: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("div", {
          class: "l-button",
          onClick: _cache[0] || (_cache[0] = $event => handlePush('check'))
        }, "下推选中"), _createElementVNode("div", {
          class: "l-button",
          onClick: handleClose
        }, "取消")]), _createElementVNode("div", null, [_createVNode(_component_el_table, {
          data: _unref(data).tableData,
          style: {
            "width": "100%",
            "margin-top": "20px",
            "overflow-y": "auto"
          },
          border: "",
          "header-row-class-name": "xthead",
          class: "xttb",
          onSelectionChange: handleSelectionChange,
          ref: "multipleTable",
          onSelectAll: selectAllChange,
          height: 550,
          onSelect: tableSelect
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            type: "selection",
            selectable: selectable,
            width: "55",
            align: "center"
          }), _createVNode(_component_el_table_column, {
            prop: "name",
            label: "任务名称",
            width: "180"
          }, {
            default: _withCtx(scope => [scope.row.examine_status == 20 ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(scope.row.name), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(scope.row.name), 1))]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "是否关键步骤",
            width: "120",
            align: "center"
          }, {
            default: _withCtx(scope => [_createElementVNode("div", null, [_createVNode(_component_el_checkbox, {
              modelValue: scope.row.checked,
              "onUpdate:modelValue": $event => scope.row.checked = $event,
              size: "large",
              label: "",
              disabled: scope.row.examine_status == 20
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])])]),
            _: 1
          }), _createVNode(_component_el_table_column, null, {
            header: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_icon, {
              size: 20,
              color: "#909399"
            }, {
              default: _withCtx(() => [_createVNode(_component_edit)]),
              _: 1
            }), _cache[1] || (_cache[1] = _createTextVNode("任务负责人 "))])]),
            default: _withCtx(scope => [_createElementVNode("div", {
              onClick: $event => getRowCol(scope.row, scope.column, scope.$index, 'leaderUser'),
              class: "selectdiv"
            }, [scope.row.isleaderUserIdShow ? (_openBlock(), _createBlock(_component_el_select, {
              key: 0,
              modelValue: scope.row.leader_user_id,
              "onUpdate:modelValue": $event => scope.row.leader_user_id = $event,
              placeholder: "请选择",
              filterable: "",
              remote: "",
              "remote-method": remoteMethod,
              disabled: scope.row.examine_status == 20
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).userlist, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.nickname,
                  value: item.id
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"])) : (_openBlock(), _createElementBlock("div", _hoisted_6, [scope.row.examine_status == 20 ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(fullName.value(scope.row.leader_user_id)), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(fullName.value(scope.row.leader_user_id)), 1))]))], 8, _hoisted_5)]),
            _: 1
          }), _createVNode(_component_el_table_column, null, {
            header: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createVNode(_component_el_icon, {
              size: 20,
              color: "#909399"
            }, {
              default: _withCtx(() => [_createVNode(_component_edit)]),
              _: 1
            }), _cache[2] || (_cache[2] = _createTextVNode("要求完成时间 "))])]),
            default: _withCtx(scope => [_createElementVNode("div", {
              onClick: $event => getRowCol(scope.row, scope.column, scope.$index, 'downTime'),
              class: "selectdiv"
            }, [scope.row.isdownTimeShow ? (_openBlock(), _createBlock(_component_el_date_picker, {
              key: 0,
              modelValue: scope.row.required_time,
              "onUpdate:modelValue": $event => scope.row.required_time = $event,
              type: "date",
              placeholder: "选择日期",
              "value-format": "YYYY/MM/DD",
              disabled: scope.row.examine_status == 20
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])) : (_openBlock(), _createElementBlock("div", _hoisted_11, [scope.row.examine_status == 20 ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(scope.row.required_time), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(scope.row.required_time), 1))]))], 8, _hoisted_10)]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"])])]),
        _: 1
      }, 8, ["model-value"])]);
    };
  }
};